"use strict";

exports.__esModule = true;
exports.typeClasses = exports.sizeClasses = void 0;
var _consts = require("../consts");
const sizeClasses = {
  [_consts.SIZE_OPTIONS.SMALL]: "text-small",
  [_consts.SIZE_OPTIONS.NORMAL]: "text-normal",
  [_consts.SIZE_OPTIONS.LARGE]: "text-large",
  [_consts.SIZE_OPTIONS.EXTRA_LARGE]: "text-extra-large"
};
exports.sizeClasses = sizeClasses;
const typeClasses = {
  [_consts.TYPE_OPTIONS.PRIMARY]: "text-link-primary-foreground hover:text-link-primary-foreground-hover active:text-link-primary-foreground-active",
  [_consts.TYPE_OPTIONS.SECONDARY]: "text-link-secondary-foreground hover:text-link-secondary-foreground-hover active:text-link-secondary-foreground-active",
  [_consts.TYPE_OPTIONS.SUCCESS]: "text-link-success-foreground hover:text-link-success-foreground-hover active:text-link-success-foreground-active",
  [_consts.TYPE_OPTIONS.INFO]: "text-link-info-foreground hover:text-link-info-foreground-hover active:text-link-info-foreground-active",
  [_consts.TYPE_OPTIONS.WARNING]: "text-link-warning-foreground hover:text-link-warning-foreground-hover active:text-link-warning-foreground-active",
  [_consts.TYPE_OPTIONS.CRITICAL]: "text-link-critical-foreground hover:text-link-critical-foreground-hover active:text-link-critical-foreground-active",
  [_consts.TYPE_OPTIONS.WHITE]: "text-link-white-foreground hover:text-link-white-foreground-hover active:text-link-white-foreground-active"
};
exports.typeClasses = typeClasses;